import http from './http';

export type Error = null | { status: any; [key: string]: any };
export type Success = any;
export type Result = Success | Error;

const onSuccess = (response: any): Promise<Result> => Promise.resolve(response.data.body);
const onError = (error: any): Promise<any> => {
    if (!error.response) {
        /* 送信するファイル読み込みの失敗などの、リクエスト送信前のエラーはerror.responseが空になると思われる */
        return Promise.reject(null);
    }
    if (error.response.data != null && typeof error.response.data === 'object') {
        if (!('status' in error.response.data)) {
            error.response.data.status = error.response.status;
        }
        return Promise.reject(error.response.data);
    } else {
        return Promise.reject({ status: error.response.status });
    }
};

export default {
    get: (url: string, params: any = null, headers: any = {}) =>
        http.get(url, { params, headers }).then(onSuccess).catch(onError),
    post: (url: string, params: any = null, headers: any = {}) =>
        http.post(url, params, { headers }).then(onSuccess).catch(onError),
    put: (url: string, params: any = null, headers: any = {}) =>
        http.put(url, params, { headers }).then(onSuccess).catch(onError),
    patch: (url: string, params: any = null, headers: any = {}) =>
        http.patch(url, params, { headers }).then(onSuccess).catch(onError),
    delete: (url: string, params: any = null, headers: any = {}) =>
        http.delete(url, { params, headers }).then(onSuccess).catch(onError),
};
